export const ItemKeys = {
  allItems: ['Items'] as const,
  listItems: () => [...ItemKeys.allItems, 'listItems'] as const,
  listItem: () => [...ItemKeys.listItems(), {}] as const,
}
